// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"f0c6bffe","361":"f7a3f22e","511":"249fce6c","767":"f1bed654"}[chunkId] + ".chunk.js";
};